export default person => `${ person?.name ?? '' } ${ person?.surname ?? '' }`.trim();
